import { render } from "./CenterSqm.vue?vue&type=template&id=af6e07aa&scoped=true"
import script from "./CenterSqm.vue?vue&type=script&lang=js"
export * from "./CenterSqm.vue?vue&type=script&lang=js"

import "./CenterSqm.vue?vue&type=style&index=0&id=af6e07aa&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6e07aa"]])

export default __exports__